import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, TrendingUp, Users } from 'lucide-react';
const benefits = [{
  icon: MessageCircle,
  title: 'Más Consultas por WhatsApp',
  description: 'Tu página web muestra tus servicios y lleva al cliente directo a WhatsApp. Cuando te escribe, ya quiere contratar.',
  color: 'text-green-400',
  bg: 'bg-green-400/10',
  border: 'border-green-400/20',
  glow: 'group-hover:shadow-green-400/20'
}, {
  icon: TrendingUp,
  title: 'Agenda Llena 24/7',
  description: 'Mientras atendés clientes, tu página sigue captando nuevos. Funciona de noche, fines de semana y feriados.',
  color: 'text-purple-400',
  bg: 'bg-purple-500/10',
  border: 'border-purple-500/20',
  glow: 'group-hover:shadow-purple-500/20'
}, {
  icon: Users,
  title: 'Imagen Profesional',
  description: 'Un diseño premium transmite la calidad de tu negocio. Los clientes confían más y están dispuestos a invertir en tus servicios.',
  color: 'text-cyan-400',
  bg: 'bg-cyan-400/10',
  border: 'border-cyan-400/20',
  glow: 'group-hover:shadow-cyan-400/20'
}];
export function BenefitsSection() {
  return <section id="beneficios" className="py-24 bg-[#050510] relative overflow-hidden" data-id="element-19">
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-20"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-23">
            ¿Por Qué Tu Negocio Necesita <br className="hidden md:block" data-id="element-24" />
            <span className="text-gradient-cosmic" data-id="element-25">Presencia Digital?</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-26">
            Porque tener redes sociales no es suficiente. Necesitás un lugar
            donde tus clientes vean tus servicios, confíen en vos y te
            contacten.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-27">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className={`group p-8 rounded-2xl bg-[#0a0a1a] border ${benefit.border} hover:border-opacity-50 transition-all duration-300 hover:-translate-y-2 ${benefit.glow} shadow-lg`} data-id="element-28">
              <div className={`w-14 h-14 rounded-xl ${benefit.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-29">
                <benefit.icon className={`w-7 h-7 ${benefit.color}`} data-id="element-30" />
              </div>
              <h3 className="text-xl font-bold font-orbitron text-white mb-4 group-hover:text-gradient-cosmic transition-colors" data-id="element-31">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-32">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}